import api from './main'

// 菜单相关API
export const menuApi = {
  // 获取公开的菜单列表（只获取可见的激活菜单）
  getPublicMenus() {
    return api.get('/system/menus/public', {
      params: { active: 'true' }
    })
  },
  getPublicMenusCatalog() {
    return api.get('/system/menus/public/catalog', {
    })
  },
  // 获取所有菜单图片、文案、链接等信息
  getAllMenuInfo(language = 'zh-CN') {
    return api.get('/system/page-contents/public', {
      params: {
        language,
        active: 'true'
      }
    })
  },
  // 根据菜单ID获取页面内容（RESTful风格）
  getPageContentByMenuId(menuId, language = 'zh-CN') {
    return api.get(`/system/page-contents/by-menu/${menuId}`, {
      params: {
        language
      }
    })
  },

  // 根据菜单路径获取页面内容
  getPageContentByMenuPath(path, language = 'zh-CN') {
    return api.get(`/system/page-contents/by-path/${encodeURIComponent(path)}`, {
      params: { language }
    })
  }
}

// 页面内容API
export const pageContentApi = {
  // 获取指定菜单的页面内容
  getContentByMenu(menuId, language = 'zh-CN') {
    return api.get('/system/page-contents', {
      params: {
        menuId,
        language,
        active: 'true'
      }
    })
  },

  // 获取所有激活的页面内容
  getActiveContents(language = 'zh-CN') {
    return api.get('/system/page-contents', {
      params: {
        language,
        active: 'true'
      }
    })
  }
}

export default api
